import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { OfferDesignForm } from './pages/OfferDesignForm/OfferDesignForm';
import OfferDesignTable from './pages/OfferDesignTable/OfferDesignTable';
import SelectOfferType from './pages/SelectOfferType/SelectOfferType';

const ROUTES: { path: string; element: React.ReactNode }[] = [
  { path: '/', element: <OfferDesignTable /> },
  { path: '/select-type', element: <SelectOfferType /> },
  { path: '/form', element: <OfferDesignForm /> },
  { path: '/form/:offerDesignId', element: <OfferDesignForm /> },
  { path: '/dup/:offerDesignId', element: <OfferDesignForm /> }
];

export const OfferDesign = (): React.ReactElement => {
  return (
    <Routes>
      {ROUTES.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}
    </Routes>
  );
};
